export function getAllCookies() {
  const cookies = document.cookie.split('; ');
  const cookieObj = {};

  cookies.forEach((cookie) => {
    const [name, value] = cookie.split('=');
    cookieObj[name] = decodeURIComponent(value);
  });

  return cookieObj;
}